// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3YVU-","errorLogs":"EditorFooter_errorLogs__1qxtX"};